import { isIOS, isAndroid } from 'react-device-detect';
import {
  CheckoutEventParams,
  ECheckoutPageEvent,
  EPlatformType,
} from 'utils/enums';
import { DeepLink } from 'utils/types';

export const getReturnToGameLinkAddress = (deepLinks: DeepLink[]) => {
  return deepLinks.find((link) => {
    if (isIOS && link.platform === EPlatformType.IOS) {
      return true;
    } else if (isAndroid && link.platform === EPlatformType.ANDROID) {
      return true;
    } else if (!isIOS && !isAndroid && link.platform === EPlatformType.WEB) {
      return true;
    }
    return false;
  })?.deepLink;
};

export const sendMessageToIframeParent = (
  eventName: ECheckoutPageEvent,
  params: Partial<CheckoutEventParams>,
) => {
  const eventData = {
    event: eventName,
    params,
  };
  window.parent.postMessage(eventData, '*');
};
